<template>
  <b-alert v-if="errors && errors.length" variant="danger" show>{{defaultError}}</b-alert>
</template>

<script>
const helpers = require('../vue/helpers');

export default {
  data: function() {
    return {};
  },
  computed: {
    defaultError: function() {
      return (
        helpers.getDefaultError(this.errors) ||
        'Não foi possível prosseguir. Verifique os erros no formulário.'
      );
    },
  },
  beforeMount: function() {},
  props: ['errors'],
  methods: {},
  components: {},
};
</script>